// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".verification-code-container{margin:0 auto;max-width:400px}.verification-code{max-width:30px!important}.verification-code .v-text-field__slot{min-height:48px!important}.verification-code input{-webkit-appearance:none!important;font-size:48px!important;line-height:normal!important;min-height:64px!important;vertical-align:middle}.progress-wrapper{height:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
